import type { MouseEvent } from 'react';

import { TextEllipsisMiddle } from '@atoms/TextEllipsisMiddle';

import { CopyToClipboardButton } from '@molecules/CopyToClipboardButton';

const UUID_DISPLAY_MAX_LENGTH = 19;

type WebhooksUuidCellProps = {
  uuid: string;
};

export const WebhooksUuidCell = ({ uuid }: WebhooksUuidCellProps) => {
  const stopRowClick = (event: MouseEvent) => event.stopPropagation();

  return (
    <div onClick={stopRowClick}>
      <CopyToClipboardButton
        text={uuid}
        displayText={
          <TextEllipsisMiddle text={uuid} maxLength={UUID_DISPLAY_MAX_LENGTH} />
        }
        className="translate-x-0 font-mono font-normal text-content-primary"
      />
    </div>
  );
};
